import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { COUNTRY_CODES } from '@pdqdev/pdq-shared/dist/utils';
import { taxFields } from '../model';
import { AddTaxIdDialog } from './dialog/add-tax-id/add-tax-id.dialog';
import { FieldType } from '@services/settings/settings.service';

@Component({
  selector: 'app-tax',
  templateUrl: './tax.component.html',
  styleUrls: ['./tax.component.scss', '../international.component.scss', '../../settings.scss'],
  standalone: false,
})
export class TaxComponent implements OnInit {
  @Input() form: UntypedFormGroup;
  @Input() dirty: boolean = false;
  @Input() fields: any[] = taxFields;

  FieldType = FieldType;
  isTaxIDsAutoApplyActive: boolean = true;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    console.log(this.form);
  }

  isControlInvalid(controlName) {
    return this.dirty && !this.form.controls[controlName].valid;
  }

  replaceWithAsterisk(value) {
    return value
      .split('')
      .map((str) => '*')
      .join('')
      .replace(/[^*]/g, '');
  }

  getCountryNameByCode(countryCode) {
    return COUNTRY_CODES.find((item) => item.code === countryCode).name || countryCode;
  }

  deleteTaxId(id) {
    let vatIds = this.form.controls['VAT_IDS'].value;
    vatIds = vatIds.filter((item) => item.taxId !== id);
    this.form.controls['VAT_IDS'].setValue(vatIds);
    this.form.markAsDirty();
  }

  openAddTaxIDWindow = () => {
    const dialogRef = this.dialog.open(AddTaxIdDialog, {
      panelClass: 'manual-verify-dialog',
      backdropClass: 'global_modal_overlay',
    });
    dialogRef.componentInstance.onAddTaxId.subscribe((data) => {
      const vatIds = this.form.controls['VAT_IDS'].value;
      this.form.controls['VAT_IDS'].setValue([...vatIds, data]);
      this.form.markAsDirty();
    });
  };
}
